type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export type SessionAttributes = {
  visitorId: string
  stylePreference: 'women' | 'men' | undefined
  customerType: 'firstTime' | 'repeat'
  isBot: boolean
  sessionId: string
  source:
    | {
        source?: string
        medium?: string
        campaign?: string
        ttCampaignId?: string
        initialPage?: string
        initialReferrer?: string
      }
    | undefined
}

export const sessionStorageKeys = {
  landingPage: '@figs:landing-page',
  usedLocales: '@figs:used-locales',
  discount: '@figs:discount',
} as const

export const convertCookiesToSessionAttributes = ({
  stylePreferenceCookie,
  initialSessionCookie,
  sessionIdCookie,
  visitorIdCookie,
  sessionSourceCookie,
}: {
  stylePreferenceCookie: string | undefined
  initialSessionCookie: string | undefined
  sessionIdCookie: string | undefined
  visitorIdCookie: string | undefined
  sessionSourceCookie: string | undefined
}): PartialBy<SessionAttributes, 'sessionId' | 'visitorId' | 'isBot'> => {
  let source: SessionAttributes['source']
  try {
    source = sessionSourceCookie ? JSON.parse(sessionSourceCookie) : undefined
  } catch {
    // error parsing cookie, default to `undefined`
    source = undefined
  }

  return {
    stylePreference: stylePreferenceCookie as 'men' | 'women' | undefined,
    customerType: initialSessionCookie === 'true' ? 'firstTime' : 'repeat',
    sessionId: sessionIdCookie,
    visitorId: visitorIdCookie,
    source,
  }
}
